export var ChangeSourceType;
(function (ChangeSourceType) {
    ChangeSourceType[ChangeSourceType["COMPONENT"] = 0] = "COMPONENT";
    ChangeSourceType[ChangeSourceType["RULESET"] = 1] = "RULESET";
    ChangeSourceType[ChangeSourceType["DOCUMENT_PUSH"] = 2] = "DOCUMENT_PUSH";
})(ChangeSourceType || (ChangeSourceType = {}));
export class ChangeSourceInfo {
}
export class StateChangeInfo {
}
